import { Component } from '@angular/core';

// Shared MoveNow/InvoNow wordmark icon, reused by the header and footer.
@Component({
    selector: 'app-landing-logo',
    standalone: true,
    templateUrl: './landing-logo.component.html',
    styleUrl: './landing-logo.component.scss'
})
export class LandingLogo {}
